import { render, staticRenderFns } from "./UserTopup.vue?vue&type=template&id=21aaae18"
import script from "./UserTopup.vue?vue&type=script&lang=js"
export * from "./UserTopup.vue?vue&type=script&lang=js"
import style0 from "./UserTopup.vue?vue&type=style&index=0&id=21aaae18&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports